import '../common/utils/polyfills';
import Api from '../common/Api';
import Ksdk from './Ksdk';
import PlayerType from '../player/PlayerType';
import { TechApi } from '../bootloader/tech';

const api = new Api();

const create = (playerType, player, playerOptions) => {
  const inst = new Ksdk(playerType, player, playerOptions, api.tech);
  api.setPlugin(inst);
  return inst;
};

function ksdk(playerType, player, playerOptions) {
  return create(playerType, player, playerOptions);
}
ksdk._internal = { tech: new TechApi() };

ksdk.forBitmovin = function (playerOptions) {
  return create(PlayerType.Bitmovin, undefined, playerOptions);
};

ksdk.forViblast = function (playerOptions) {
  return create(PlayerType.Viblast, {}, playerOptions);
};

ksdk.forViblastVideoJS = function (player) {
  return create(PlayerType.Viblast, player);
};

ksdk.forVideoJS = function (player, playerOptions) {
  return create(PlayerType.VideoJS, player, playerOptions);
};

ksdk.forShaka = function (player) {
  return create(PlayerType.Shaka, player);
};

ksdk.forFlowplayer = function (player) {
  return create(PlayerType.Flowplayer, player);
};

ksdk.forHLSjs = function (videoElement, hlsConfig) {
  return create(PlayerType.HLSjs, videoElement, hlsConfig);
};

ksdk.forHLSjsConfig = function (hlsConfig) {
  return create(PlayerType.HLSjsConfig, hlsConfig);
};

ksdk.forTHEOplayer = function (player) {
  return create(PlayerType.THEOplayer, player);
};

ksdk.forFetchFactory = function (options) {
  return create(PlayerType.FetchFactoryPlayer, options);
};

// TODO - add when amp is ready
// ksdk.forAMP = function(player) {
//   return create(AMP, player);
// };

// access to logger etc on the top level object.
ksdk.api = api;

export default ksdk;
